import { render } from "./LogOutFrontSvgIcon.vue?vue&type=template&id=42979806"
import script from "./LogOutFrontSvgIcon.vue?vue&type=script&lang=js"
export * from "./LogOutFrontSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__